import { render, staticRenderFns } from "./ListPerSupplierPrint.vue?vue&type=template&id=6871dc19&scoped=true"
import script from "./ListPerSupplierPrint.vue?vue&type=script&lang=js"
export * from "./ListPerSupplierPrint.vue?vue&type=script&lang=js"
import style0 from "./ListPerSupplierPrint.vue?vue&type=style&index=0&id=6871dc19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871dc19",
  null
  
)

export default component.exports